import { useQuery } from "react-query";
import { fetchPatientReminders } from "@/services/tasks";
/** Query hook for a patient's reminders/tasks. */
export function usePatientReminders(patientUid) {
  return useQuery(["patient-reminders", patientUid], function () {
    return fetchPatientReminders(patientUid);
  }, {
    enabled: Boolean(patientUid)
  });
}